import React from 'react';
import { Box, Link,Typography } from '@mui/material'
import params from "../../../setup/config/params.json"

const Footer = () => {
    return (
        <Box sx={{ component:"footer", backgroundColor: '#0d3559', color: 'white', textAlign: 'center', py: 2,
                position: 'fixed',
                bottom: 0,
                width: '100%',
                zIndex: 1000,
            }}
        >
            <Typography variant="body2" component="p">
                &copy; {new Date().getFullYear()}{" "}
                <a 
                    href={params.site.url.website} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {params.site.name}
                </a>
            </Typography>
        </Box>
    );
};

export default Footer;